export const subscriptionsStore = {
    allSubscriptionsPlans: [],
    currency: '',
};
